export const loggedIn = (state) => state.loggedIn;
